<main
    class="agpr-monitoringSearch"
    [class.agpr-monitoringSearch--panel]="panelMode"
    [class.agpr-monitoringSearch--panelEdit]="panelMode && savedTopic"
    [formGroup]="searchForm"
>
    <h2 class="u-srOnly">{{ 'Monitoring.search.monitoringSearchSetup' | localize }}</h2>

    <ng-template #actionBar>
        <agpr-action-bar
            [headingContext]="'Monitoring.search.search' | localize"
        >
            <ng-template #left>
                @if (panelMode) {
                    <agpr-button
                        label="Monitoring.search.cancel"
                        [id]="id + '_CancelButton'"
                        [style]="buttonTypes.secondary"
                        (click)="cancelRequested.emit()"
                    ></agpr-button>
                }
                @if (currentRoute.type === routeTypes.updateSearch ||
                    ((currentRoute.type === routeTypes.search || panelNewSearch) && isDirty)
                ) {
                    <agpr-button
                        label="Monitoring.search.resetAll"
                        [id]="id + '_resetAllButton'"
                        [style]="buttonTypes.secondary"
                        (click)="resetAll()"
                    ></agpr-button>
                }
                @if (isDirty && savedTopic) {
                    <agpr-button
                        label="Monitoring.search.undoAllChanges"
                        [id]="id + '_UndoAllChangesButton'"
                        [style]="buttonTypes.secondary"
                        (click)="undo()"
                    ></agpr-button>
                }
            </ng-template>
            <ng-template #right>
                @if (selectedTabIndex === searchTab.newCoverage &&
                    (currentRoute.type == routeTypes.updateSearch || currentRoute.type === routeTypes.search || panelNewSearch)
                ) {
                    <agpr-button
                        label="Monitoring.saveSearchAsTopic"
                        [id]="id + '_SaveSearchAsTopicButton'"
                        [style]="buttonTypes.primaryB"
                        (click)="saveAs()"
                    ></agpr-button>
                }
                @if (isDirty && savedTopic) {
                    <agpr-split-button
                        [panelPositionY]="'top'"
                        [panelPositionX]="'right'"
                        [options]="saveActions"
                        label="Monitoring.save"
                        [id]="id + '_SaveSearchActionsButton'"
                        [style]="buttonTypes.primaryB"
                    ></agpr-split-button>
                }
                <agpr-button
                    [id]="id + '_SearchButton'"
                    label="Monitoring.search.search"
                    [style]="buttonTypes.primary"
                    (click)="performSearch()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </ng-template>

    <div class="agpr-monitoringSearch-container">
        <section
            class="agpr-monitoringSearch-centerPanel"
            [attr.aria-label]="'Common.layout.main' | localize"
        >
            @if (hasAgent && !search?.id && currentRoute.type === routeTypes.search) {
                <agpr-agent-banner
                    class="agpr-monitoringSearch-agentBanner"
                    [id]="id + '_create'"
                    [headerTitle]="'Monitoring.search.agilityAgent.create'"
                    [hasAgentDebug]="hasAgentDebug"
                    [(naturalLanguagePrompt)]="naturalLanguagePrompt"
                    [(taskDescription)]="taskDescription"
                    [(systemPrompt)]="systemPrompt"
                    [(topicSystemPrompt)]="topicSystemPrompt"
                    (submit)="showContextTakeover($event)"
                ></agpr-agent-banner>
            }
            <div class="agpr-monitoringSearchType">
                @if (currentRoute.type === routeTypes.search || currentRoute.type === routeTypes.updateSearch || panelNewSearch) {
                    <agpr-tabs
                        [selectedTabIndex]="selectedTabIndex"
                        (selectedTabIndexChange)="tabChange($event)"
                    >
                        <agpr-tab
                            [icon]="'fa-regular fa-duotone fa-magnifying-glass'"
                            [heading]="'Monitoring.search.context.type.searchNewCoverage'"
                            [id]="id + '_newCoverageTab'"
                        ></agpr-tab>
                        <agpr-tab
                            [icon]="'fa-regular fa-duotone fa-floppy-disk'"
                            [heading]="'Monitoring.search.context.type.searchSavedCoverage'"
                            [id]="id + '_savedCoverageTab'"
                        ></agpr-tab>
                    </agpr-tabs>
                }
            </div>
            <agpr-scroll-panel>
                <div
                    class="agpr-monitoringSearch-content"
                    formGroupName="requiredSource"
                >
                    @if (hasAgent && (panelMode || (search?.id && savedTopic))) {
                        <agpr-agent-banner
                            class="agpr-monitoringSearch-agentBanner"
                            [id]="id + '_refine'"
                            [headerTitle]="'Monitoring.search.agilityAgent.update'"
                            [placeholder]="'Monitoring.search.prcopilot.updatePlaceholder'"
                            [(naturalLanguagePrompt)]="naturalLanguagePrompt"
                            (submit)="refineExistingTopic($event)"
                        ></agpr-agent-banner>
                    }
                    <div
                        class="agpr-monitoringSearch-content-buttons"
                    >
                        <agpr-button
                            [id]="id + '_modeToggleButton'"
                            class="agpr-expertBoolean-toggleButton"
                            [label]="searchModelButtonLabel"
                            [style]="buttonTypes.textToggle"
                            (click)="changeSearchMode()"
                        ></agpr-button>
                        @if (!expertBooleanSearchEnabled) {
                            <agpr-button
                                [id]="id + '_addKeywordGroup'"
                                class="agpr-monitoringSearch-addKeywordGroup"
                                [style]="buttonTypes.icon"
                                icon="fa-regular fa-duotone fa-square-plus"
                                [disabled]="hasEmptyKeywordGroup"
                                [tooltip]="requiredSource.errors?.['sourceRequiredError'] || hasEmptyKeywordGroup ? 'Monitoring.keyWords.addKeywordGroup.disabled' : 'Monitoring.keyWordGroup.addKeywordGroup'"
                                (click)="addKeywordGroup()"
                            ></agpr-button>
                        }
                    </div>
                    <ng-container
                        formGroupName="keywords"
                    >
                        @if (!expertBooleanSearchEnabled) {
                            <div
                                class="agpr-monitoringSearch-keywordGroups"
                                formArrayName="keywordGroups"
                            >
                                <ng-container *ngFor="let keywordGroup of keywordGroups.controls; let i = index;">
                                    <agpr-monitoring-keyword-group
                                        [formControl]="keywordGroup"
                                        [id]="id + '_keywordGroup_' + i"
                                        styleClass="agpr-monitoringSearch-keywordGroup"
                                        [showDelete]="keywordGroups.controls.length > 1"
                                        [index]="i"
                                        [ariaDescribedBy]="id + '_keywordGroup_' + i + '_error'"
                                        (deleteClicked)="deleteKeywordGroup(i)"
                                    ></agpr-monitoring-keyword-group>
                                    <ul [id]="id + '_keywordGroup_' + i + '_error'">
                                        @if (keywords.errors?.['searchContextError']) {
                                            <li>
                                                <agpr-form-message>
                                                    {{ 'Monitoring.search.searchContextNotSelectedError' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                        @if (keywordGroup.errors?.['keywordError']) {
                                            <li>
                                                <agpr-form-message>
                                                    {{ 'Monitoring.search.keywordConflictMessage' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                        @if (requiredSource.errors?.['sourceRequiredError'] && !discoverList.errors?.['discoverListRequired'] && showErrors) {
                                            <li>
                                                <agpr-form-message>
                                                    {{ 'Monitoring.search.oneOfKeywordOrSourceRequired' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                        @if (keywords.errors?.['maxLengthError'] && showErrors) {
                                            <li>
                                                <agpr-form-message>
                                                {{ 'Monitoring.search.standardBooleanSearch.queryTooLong' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        }
                                    </ul>
                                </ng-container>
                                @if (keywordGroups.errors?.['keywordGroupsError'] && showErrors) {
                                    <agpr-form-message>
                                        {{ 'Monitoring.search.keywordGroupConflictMessage' | localize }}
                                    </agpr-form-message>
                                }
                            </div>
                        } @else {
                            <div>
                                <agpr-monitoring-expert-boolean-search
                                    formControlName="expertBooleanQuery"
                                    [ariaDescribedBy]="id + '_expertBoolean_error'"
                                ></agpr-monitoring-expert-boolean-search>
                                <ul [id]="id + '_expertBoolean_error'">
                                    @if (requiredSource.errors?.['sourceRequiredError'] && !discoverList.errors?.['discoverListRequired'] && showErrors) {
                                        <li>
                                            <agpr-form-message>
                                                {{ 'Monitoring.search.oneOfKeywordOrSourceRequired' | localize }}
                                            </agpr-form-message>
                                        </li>
                                    }
                                    @if (keywords.errors?.['searchContextError']) {
                                        <li>
                                            <agpr-form-message>
                                                {{ 'Monitoring.search.searchContextNotSelectedError' | localize }}
                                            </agpr-form-message>
                                        </li>
                                    }
                                    @if (keywords.errors?.['maxLengthError'] && showErrors) {
                                        <li>
                                            <agpr-form-message>
                                                {{ 'Monitoring.search.expertBooleanSearch.queryTooLong' | localize: {'queryLength': expertKeywords.value.filter.length} }}
                                            </agpr-form-message>
                                        </li>
                                    }
                                    @if (expertKeywords.errors?.['minLengthError'] && showErrors) {
                                        <li>
                                            <agpr-form-message>
                                                {{ 'Monitoring.search.expertBooleanSearch.queryTooShort' | localize }}
                                            </agpr-form-message>
                                        </li>
                                    }
                                    @if (expertKeywords.errors?.['pureNot'] && showErrors) {
                                        <li>
                                            <agpr-form-message>
                                                {{ 'Monitoring.search.expertBooleanSearch.pureNot' | localize }}
                                            </agpr-form-message>
                                        </li>
                                    }
                                    @if (expertKeywords.errors?.['invalidExpertQueryError']) {
                                        <li>
                                            <agpr-form-message>
                                                {{ expertQueryError | localize }}
                                            </agpr-form-message>
                                        </li>
                                    }
                                </ul>
                            </div>
                        }
                    </ng-container>
                </div>
            </agpr-scroll-panel>
            @if (showAgenticUpsell) {
                <agpr-agentic-upsell-banner
                    class="agpr-monitoringSearch-agenticUpsell"
                    [id]="id + '_agenticUpsell'"
                    [heading]="agenticUpsellHeading"
                    [message]="agenticUpsellMessage"
                ></agpr-agentic-upsell-banner>
            }
            @if (!panelMode) {
                <ng-container *ngTemplateOutlet="actionBar"></ng-container>
            }
        </section>
        <aside
            class="agpr-monitoringSearch-sidebar"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-right-sidebar #rhpSidebar>
                <agpr-tab
                    [id]="id + '_SearchSlidersTab'"
                    icon=" fa-sliders"
                    tooltip="Monitoring.search.rhp.setup"
                >
                    <agpr-panel
                        header="Monitoring.search.mediaTypes"
                    >
                        <agpr-media-type-checkbox
                            formControlName="mediaTypes"
                            [isImageSearch]="isImageSearch"
                            [saveSearch]="selectedTabIndex === searchTab.savedCoverage"
                            ariaDescribedBy="noMediaTypes_error"
                        ></agpr-media-type-checkbox>
                        @if (mediaTypes.errors?.['required']) {
                            <agpr-form-message
                                id="noMediaTypes_error"
                            >
                                {{ 'MediaTypeCheckbox.pleaseSelectAMediaType' | localize }}
                            </agpr-form-message>
                        }
                    </agpr-panel>
                    <ng-container
                        formGroupName="requiredSource"
                    >
                        @if (selectedTabIndex === searchTab.savedCoverage) {
                            <agpr-panel
                                header="Monitoring.search.collections"
                                tooltip="Monitoring.search.collectionsTooltip"
                                class="rhp-panel"
                                formGroupName="folderTag"
                            >
                                <div class="u-marginBottom--md">
                                    <label
                                        [id]="id + '_include_label'"
                                        class="agpr-includeExclude-labels agpr-monitoringSearch-label"
                                    >
                                        {{ 'Monitoring.search.include' | localize }}
                                    </label>
                                    <agpr-multiselect-autocomplete
                                        formControlName="folderTagInclude"
                                        [id]="id + '_include_dropdownAutocomplete'"
                                        dropdownAriaLabel="Monitoring.search.selectAField"
                                        [showHiddenOption]="true"
                                    ></agpr-multiselect-autocomplete>
                                    @if (requiredSource.errors?.['sourceRequiredError'] && !discoverList.errors?.['discoverListRequired'] && showErrors) {
                                        <agpr-form-message
                                            [id]="id + '_rhp_includedFolderTag_error'"
                                        >
                                            {{ 'Monitoring.search.oneOfKeywordOrSourceRequired' | localize }}
                                        </agpr-form-message>
                                    }
                                </div>

                                <div>
                                    <label
                                        [id]="id + '_exclude_label'"
                                        class="agpr-includeExclude-labels agpr-monitoringSearch-label"
                                    >
                                        {{ 'Monitoring.search.exclude' | localize }}
                                    </label>
                                    <agpr-multiselect-autocomplete
                                        formControlName="folderTagExclude"
                                        [id]="id + '_exclude_dropdownAutocomplete'"
                                        dropdownAriaLabel="Monitoring.search.selectAField"
                                        [showHiddenOption]="true"
                                    ></agpr-multiselect-autocomplete>
                                </div>
                                @if (folderTag.errors?.['folderTagError']) {
                                    <agpr-form-message
                                        [id]="id + '_rhp_folderTag_error'"
                                    >
                                        {{ 'Monitoring.search.folderTagConflictError' | localize }}
                                    </agpr-form-message>
                                }
                            </agpr-panel>
                        }
                        <agpr-panel
                            header="Monitoring.search.sources"
                            formGroupName="sources"
                        >
                            <div class="u-marginBottom--md">
                                <div class="u-horizontalSpaceBetween agpr-monitoringSearch-label">
                                    <label class="u-block u-xsBottomMargin agpr-monitoringSearch-sourceLabel">
                                        {{ 'Monitoring.search.include' | localize }}
                                    </label>
                                </div>
                                <agpr-include-exclude-source-picker
                                    formControlName="includedSources"
                                    [id]="id + '_rhp_includedSources'"
                                    [dropdownChoices]="includedSourceOptions"
                                    dropdownAriaLabel="Monitoring.search.include"
                                    field="displayString"
                                    [showManageIcon]="true"
                                    [manageDialog]="manageSourceDialog"
                                    [ariaDescribedBy]="id + '_rhp_includedSources_error'"
                                    [placeholder]="'Monitoring.search.sources.placeholder'"
                                ></agpr-include-exclude-source-picker>
                                @if (requiredSource.errors?.['sourceRequiredError'] && !discoverList.errors?.['discoverListRequired'] && showErrors) {
                                    <agpr-form-message
                                        [id]="id + '_rhp_includedSources_error'"
                                    >
                                        {{ 'Monitoring.search.oneOfKeywordOrSourceRequired' | localize }}
                                    </agpr-form-message>
                                }
                                @if (showSaveIncludeSources) {
                                    <div class="agpr-monitoringSearch-saveAsGroup">
                                        <agpr-button
                                            [id]="id + '_rhp_includedSources_saveAsGroup'"
                                            [style]="buttonTypes.tertiary"
                                            label="Monitoring.search.saveSourceGroup"
                                            (click)="openSaveAsGroupDialog(includeOrExclude.include)"
                                        ></agpr-button>
                                    </div>
                                }
                            </div>
                            <div>
                                <div class="u-horizontalSpaceBetween agpr-monitoringSearch-label">
                                    <label class="u-block u-xsBottomMargin agpr-monitoringSearch-sourceLabel">
                                        {{ 'Monitoring.search.exclude' | localize }}
                                    </label>
                                </div>
                                <agpr-include-exclude-source-picker
                                    formControlName="excludedSources"
                                    id="monitoringSearchSidebar.excludedSources"
                                    [dropdownChoices]="excludedSourceOptions"
                                    dropdownAriaLabel="Monitoring.search.exclude"
                                    field="displayString"
                                    [showManageIcon]="true"
                                    [manageDialog]="manageSourceDialog"
                                    [placeholder]="'Monitoring.search.sources.placeholder'"
                                ></agpr-include-exclude-source-picker>
                                @if (showSaveExcludeSources) {
                                    <div class="agpr-monitoringSearch-saveAsGroup">
                                        <agpr-button
                                            [id]="id + '_rhp_excludedSources_saveAsGroup'"
                                            [style]="buttonTypes.tertiary"
                                            label="Monitoring.search.saveSourceGroup"
                                            (click)="openSaveAsGroupDialog(includeOrExclude.exclude)"
                                        ></agpr-button>
                                    </div>
                                }
                            </div>

                        </agpr-panel>
                        @if (showSection){
                        <agpr-panel
                            class="agpr-monitoringSearch-discoverList"
                            header="Monitoring.search.discoverLists"
                            [headerIcon]="!hasTargeting ? 'fa-regular fa-lock fa-duotone' : null"
                            [headerIconTooltip]="!hasTargeting ? 'Monitoring.search.discoverLists.lockTooltip' : null"
                            [collapsed]="!hasTargeting"
                        >
                            @if (hasTargeting) {
                                <agpr-discover-list-picker
                                    formControlName="discoverListFilter"
                                    (isDirty) = checkDiscoverListFilterDirty($event)
                                ></agpr-discover-list-picker>
                                @if (discoverList.errors?.['discoverListCountError'] && showErrors) {
                                    <agpr-message
                                        [id]="id + '_rhp_discoverListCount_error'"
                                        [severity]="messageSeverityEnum.error"
                                    >
                                        <p> {{ 'Discover.listPicker.contactExceedLimit' | localize }} </p>
                                        <p> {{ 'Discover.listPicker.contactExceedLimit.message' | localize: {contactLimit: sourceContactLimit} }} </p>
                                    </agpr-message>
                                }
                                @if (discoverList.errors?.['discoverListRequired'] && showErrors) {
                                    <agpr-form-message
                                        [id]="id + '_rhp_discoverListRequired_error'"
                                    >
                                        {{ 'Monitoring.search.discoverLists.required' | localize }}
                                    </agpr-form-message>
                                }
                            }

                            @else {
                                <div class="agpr-monitoringSearch-discoverList-upsell">
                                    <img
                                        class="agpr-monitoringSearch-discoverList-upsell-logo"
                                        [src]="appBaseHref + 'assets/images/discover_upsell.svg'"
                                        alt=""
                                    />
                                    <span> {{ 'Core.navigation.mediaRelations.unlock' | localize }} </span>
                                    <agpr-button
                                        [style]="buttonTypes.primary"
                                        [label]="isPaMedia ? 'Core.navigation.support.contact' : 'Monitoring.search.discoverLists.upsellButton'"
                                        id="monitoringSearch_upsellDiscover_button"
                                        (click)="openDiscoverUpsellDialog()"
                                    ></agpr-button>
                                </div>
                            }
                        </agpr-panel>
                    }
                    </ng-container>

                    <agpr-panel
                        header="Monitoring.search.regions"
                        formGroupName="regions"
                    >
                        <div class="u-marginBottom--md">
                            <div class="u-horizontalSpaceBetween agpr-monitoringSearch-label">
                                <label class="u-block u-xsBottomMargin">
                                    {{ 'Monitoring.search.include' | localize }}
                                </label>
                            </div>
                            <div class="agpr-monitoringSearch-browseAllContainer">
                                <agpr-autocomplete-chips
                                    formControlName="includedRegions"
                                    id="monitoringSearchSidebar.includedRegions"
                                    field="displayString"
                                    duplicateCheckField="id"
                                    class="agpr-monitoringSearch-browseAllInput"
                                    [autocompleteOptions]="regionsAutocompleteOptions"
                                    ariaLabel="Monitoring.search.includeRegions"
                                    [ariaInvalid]="regions.errors?.['regionError']"
                                    [ariaDescribedBy]="id + '_rhp_regions_error'"
                                    placeholder="Monitoring.search.regions.placeholder"
                                    [button]="{
                                        icon: 'fa-regular fa-duotone fa-binoculars',
                                        tooltip: 'Monitoring.search.browseAll'
                                        }"
                                    (buttonPress)="showRegions('includedRegions', includeOrExclude.include)"
                                ></agpr-autocomplete-chips>
                            </div>
                        </div>
                        <div>
                            <div class="u-horizontalSpaceBetween agpr-monitoringSearch-label">
                                <label class="u-block u-xsBottomMargin">
                                    {{ 'Monitoring.search.exclude' | localize }}
                                </label>
                            </div>
                            <div class="agpr-monitoringSearch-browseAllContainer">
                                <agpr-autocomplete-chips
                                    formControlName="excludedRegions"
                                    id="monitoringSearchSidebar.excludedRegions"
                                    field="displayString"
                                    duplicateCheckField="id"
                                    class="agpr-monitoringSearch-browseAllInput"
                                    [autocompleteOptions]="regionsAutocompleteOptions"
                                    ariaLabel="Monitoring.search.excludeRegions"
                                    [ariaInvalid]="regions.errors?.['regionError']"
                                    [ariaDescribedBy]="id + '_rhp_regions_error'"
                                    placeholder="Monitoring.search.regions.placeholder"
                                    [button]="{
                                        icon: 'fa-regular fa-duotone fa-binoculars',
                                        tooltip: 'Monitoring.search.browseAll'
                                    }"
                                    (buttonPress)="showRegions('excludedRegions', includeOrExclude.exclude)"
                                ></agpr-autocomplete-chips>
                            </div>
                        </div>
                        @if (regions.errors?.['regionError']) {
                            <agpr-form-message
                                [id]="id + '_rhp_regions_error'"
                            >
                                {{ 'Monitoring.search.regionsConflictError' | localize }}
                            </agpr-form-message>
                        }
                    </agpr-panel>
                    <agpr-panel
                        header="Monitoring.search.languages"
                        formGroupName="languages"
                    >
                        <div class="u-marginBottom--md">
                            <div class="u-horizontalSpaceBetween agpr-monitoringSearch-label">
                                <label class="u-block u-xsBottomMargin">
                                    {{ 'Monitoring.search.include' | localize }}
                                </label>
                            </div>
                            <div class="agpr-monitoringSearch-browseAllContainer">
                                <agpr-autocomplete-chips
                                    formControlName="includedLanguages"
                                    [id]="id + '_rhp_includedLanguages'"
                                    field="name"
                                    class="agpr-monitoringSearch-browseAllInput"
                                    [autocompleteOptions]="languagesAutocompleteOptions"
                                    ariaLabel="Monitoring.search.includeLanguages"
                                    placeholder="Monitoring.search.language.placeholder"
                                    [button]="{
                                        icon: 'fa-regular fa-duotone fa-binoculars',
                                        tooltip: 'Monitoring.search.browseAll'
                                    }"
                                    (buttonPress)="showLanguages('includedLanguages', includeOrExclude.include)"
                                ></agpr-autocomplete-chips>
                            </div>
                        </div>
                        <div>
                            <div class="u-horizontalSpaceBetween agpr-monitoringSearch-label">
                                <label class="u-block u-xsBottomMargin">
                                    {{ 'Monitoring.search.exclude' | localize }}
                                </label>
                            </div>
                            <div class="agpr-monitoringSearch-browseAllContainer">
                                <agpr-autocomplete-chips
                                    formControlName="excludedLanguages"
                                    [id]="id + '_rhp_excludedLanguages'"
                                    field="name"
                                    class="agpr-monitoringSearch-browseAllInput"
                                    [autocompleteOptions]="languagesAutocompleteOptions"
                                    ariaLabel="Monitoring.search.excludeLanguages"
                                    placeholder="Monitoring.search.language.placeholder"
                                    [button]="{
                                        icon: 'fa-regular fa-duotone fa-binoculars',
                                        tooltip: 'Monitoring.search.browseAll'
                                    }"
                                    (buttonPress)="showLanguages('excludedLanguages', includeOrExclude.exclude)"
                                ></agpr-autocomplete-chips>
                            </div>
                        </div>
                        @if (languages.errors?.['languageError']) {
                            <agpr-form-message
                                [id]="id + '_rhp_languages_error'"
                            >
                                {{ 'Monitoring.search.languagesConflictError' | localize }}
                            </agpr-form-message>
                        }
                    </agpr-panel>
                    <agpr-panel
                        header="Monitoring.search.sentiment"
                        [tooltip]="'Monitoring.sentiment.tooltip' | localize"
                    >
                        <agpr-checkbox-filter
                            formControlName="sentiments"
                            [options]="availableSentiments"
                            [includeSelectAll]="false"
                        ></agpr-checkbox-filter>
                    </agpr-panel>
                    <agpr-panel
                        header="Monitoring.search.otherSearchSettings"
                    >
                        <agpr-checkbox
                            formControlName="caseSensitive"
                            [id]="id + '_rhp_caseSensitiveSearchingCheckbox'"
                            class="agpr-monitoringSearch-otherSettingsCheckbox"
                            label="Monitoring.search.caseSensitiveSearching"
                            [binary]="true"
                            infoCircleTooltip="Monitoring.search.caseSensitiveSearching.tooltip"
                        ></agpr-checkbox>
                        <agpr-checkbox
                            formControlName="hideSimilar"
                            [id]="id + '_rhp_hideSimilarCheckbox'"
                            class="agpr-monitoringSearch-otherSettingsCheckbox"
                            label="Monitoring.search.hideSimilar"
                            [binary]="true"
                        ></agpr-checkbox>
                        <div class="agpr-monitoringSearch-dateRangeSelector">
                            <label>
                                {{ 'Monitoring.search.defaultDateRange' | localize }}
                            </label>
                            <agpr-date-query-popup
                                formControlName="dateQuery"
                                [id]="id + '_rhp_dateQuery'"
                                class="agpr-monitoringSearch-dateQueryInput"
                                [header]="'Monitoring.search.defaultDateRange'"
                                [options]="dateFilterOptions"
                                [searchRange]="searchRange"
                            ></agpr-date-query-popup>
                        </div>
                    </agpr-panel>
                </agpr-tab>
                <agpr-tab
                    [id]="id + '_rhp_TopicSettingsTab'"
                    icon=" fa-solid fa-wrench"
                    tooltip="Monitoring.search.rhp.topicSettings"
                >
                    <agpr-panel
                        header="Monitoring.search.topicPurpose"
                        class="agpr-monitoringSearch-topicPurposePanel"
                        [paddingBottom]="0"
                    >
                        <agpr-textarea-input
                            [id]="id + '_rhp_searchIntent'"
                            formControlName="searchIntent"
                            [placeholder]="'Monitoring.search.topicPurpose.placeholder' | localize"
                            [maxLength]="2056"
                            [rows]="5"
                        ></agpr-textarea-input>
                    </agpr-panel>
                    @if (savedTopic) {
                        <agpr-panel
                            header="TopicWorkflowSettings.topicWorkflowSettings"
                        >
                            <agpr-topic-workflow-settings
                                formGroupName="topicWorkFlowSettings"
                                [showErrors]="showErrors"
                            ></agpr-topic-workflow-settings>
                        </agpr-panel>
                    }
                </agpr-tab>
                <agpr-tab
                    [id]="id + '_rhp_SummaryTab'"
                    icon=" fa-file-lines"
                    tooltip="Monitoring.search.rhp.summary"
                >
                    <agpr-monitoring-result-summary
                        [criteria]="search?.searchCriteria"
                    ></agpr-monitoring-result-summary>
                </agpr-tab>
                @if (hasAdminPermission && savedTopic) {
                    <agpr-tab
                        [id]="'monitoringSearchBackfill'"
                        icon=" fa-clock-rotate-left"
                        tooltip="Monitoring.search.rhp.backfill"
                    >
                        <agpr-message
                            [severity]="messageSeverityEnum.info"
                        >
                            {{ 'Monitoring.search.backfill.infoMessage' | localize }}
                        </agpr-message>
                        <agpr-panel
                            header="Monitoring.search.backfill.status"
                        >
                            <ng-container *ngFor="let atts of backfillAttributes; let last = last">
                                <div class="agpr-monitoringSearch-backfillList">
                                    <agpr-attribute-list
                                        [attributes]="atts"
                                    ></agpr-attribute-list>
                                </div>
                                @if (!last) {
                                    <div class="agpr-monitoringSearch-separator"></div>
                                }
                            </ng-container>
                        </agpr-panel>
                        <ng-template #tabFooter>
                            <agpr-action-bar>
                                <ng-template #left>
                                    <agpr-button
                                        label="New backfill request"
                                        [style]="buttonTypes.tertiary"
                                        (click)="backfill()"
                                    ></agpr-button>
                                </ng-template>
                                <ng-template #right>
                                    <agpr-button
                                        label="Refresh"
                                        [style]="buttonTypes.tertiary"
                                        (click)="refreshTopics()"
                                    ></agpr-button>
                                </ng-template>
                            </agpr-action-bar>
                        </ng-template>
                    </agpr-tab>
                }
            </agpr-right-sidebar>
        </aside>
    </div>
    @if (panelMode) {
        <ng-container *ngTemplateOutlet="actionBar"></ng-container>
    }
</main>
